<template>
  <div :class="attrCss" role="group" :aria-labelledby="id">
    <span v-if="changeBadge" :class="'changeBadge-' + changeType">{{
      changeBadge
    }}</span>
    <div :class="rowCss">
      <div class="label cell">
        <span class="changeLabel">{{ label }}</span>
      </div>

      <div
        v-if="valueBefore"
        :title="valueBeforeDescription"
        class="before cell"
      >
        <span class="changeBadge-before">{{
          resolveTxt("diff.badge.before", "Before")
        }}</span>
        <template v-if="typeof valueBefore === 'object' && valueBefore.link">
          <a
            class="changeValue-after link"
            target="_blank"
            download
            :href="valueBefore.link"
            >{{ valueBefore.text }}</a
          >
        </template>
        <template v-else
          ><span class="changeValue-before">{{ valueBefore }}</span></template
        >
      </div>
      <div v-if="valueBefore" role="presentation" class="diff-arrow cell">
        <i class="icon-right"></i>
      </div>
      <div class="after cell">
        <span class="changeBadge-after">{{
          resolveTxt("diff.badge.after", "After")
        }}</span>
        <template v-if="typeof valueAfter === 'object' && valueAfter.link">
          <a
            class="changeValue-after link"
            target="_blank"
            download
            :href="valueAfter.link"
            >{{ valueAfter.text }}</a
          >
        </template>
        <template v-else
          ><span class="changeValue-after">{{ valueAfter }}</span></template
        >
      </div>
    </div>
    <slot></slot>
  </div>
</template>
<script lang="ts">
import { defineComponent, inject } from "vue";
import { defaultResolveTxt } from "@/components/field-element";

export default defineComponent({
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", defaultResolveTxt);
    const displayParams = inject("displayParams", false);

    return {
      resolveTxt,
      displayParams
    };
  },
  name: "AttributeDiff",
  props: {
    id: [String],
    label: [String],
    valueBefore: [String, Number, Object],
    valueBeforeDescription: {
      type: String,
      default: "Before change"
    },
    valueAfter: [String, Number, Object],
    valueAfterDescription: {
      type: String,
      default: "After change"
    },
    changeType: [String],
    styles: [Array],
    suppressBadges: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    attrCss: function () {
      var css = ["cat-attribute-readonly-wrapper", "diff-attribute"];
      if (this.changeType) {
        css.push("changeType");
      }
      return css;
    },
    rowCss: function () {
      var css = ["grid-x"];
      if (this.changeType) {
        css.push("radius-r changeType-" + this.changeType, "pbt pls prs pts");
      }
      return css;
    },
    changeBadge: function () {
      if (
        !this.changeType ||
        "none" === this.changeType ||
        this.suppressBadges
      ) {
        return null;
      }
      return this.resolveTxt("diff.badge." + this.changeType, this.changeType);
    }
  }
});
</script>
